export default __webpack_public_path__ + "static/media/T14B.9f289ce9.png";